function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconLanguageRexFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M21.5 14.09A7.18 7.18 0 0023.13 12h-3.26a7.18 7.18 0 001.63 2.09zM9.17 14.56h2.49l-1.25-3.93-1.24 3.93z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 2H4a2 2 0 00-2 2v19a2 2 0 002 2h7.5l4.5 5 4.5-5H28a2 2 0 002-2V4a2 2 0 00-2-2zM12.76 18l-.58-1.82H8.66L8.09 18h-1.9l3.17-9.09h2.25L14.77 18h-2.01zm13.74-6h-1.22a8.27 8.27 0 01-2.08 3.24 7.371 7.371 0 003.3.76v2a9.39 9.39 0 01-5-1.43 9.39 9.39 0 01-5 1.43v-2a7.371 7.371 0 003.3-.76A8.27 8.27 0 0117.72 12H16.5v-2h4V8h2v2h4v2z",
    fill: props.color
  }));
}

export default SvgIconLanguageRexFilled;